import { Listbox } from '@headlessui/react';

import type {
    SelectComponentProps,
    OptionType
} from '@/components/base/Select/SelectComponent/types';

type SelectLabelProps<TOption, TSelected> = Readonly<
    Pick<SelectComponentProps<TOption, TSelected>, 'label' | 'required'>
>;
export function SelectLabel<TOption extends OptionType, TSelected extends TOption | TOption[]>({
    label,
    required
}: SelectLabelProps<TOption, TSelected>) {
    if (!label) {
        return null;
    }

    return (
        <Listbox.Label className="mb-2 block text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
            {label}
            {required ? <span className="text-icoBlue">*</span> : null}
        </Listbox.Label>
    );
}
